module.exports = __webpack_public_path__ + "static/bg-fe5119a42023907373f44f847c21cbdc.jpg";